@if (this.insuranceClaim$ | async; as insuranceClaim) {
  <div class="sub-header">
    <div class="sub-header-row border-top align-items-center px-1">
      <div class="row">
        @if (this.customActions$ | async; as customActions) {
          <div class="col">
            @for (action of customActions; track action.name + action.actionName) {
              <a
                [class]="action.buttonType | buttontypepipe"
                class="btn-sm btn"
                (click)="triggerStatusFlow(action.actionName, insuranceClaim.id)"
              >
                {{ action.title }}
              </a>
            }
          </div>
        }
        @if (this.insuranceClaimStatusFlows$ | async; as insuranceClaimStatusFlowList) {
          <div
            class="col-auto state-breadcrumb-col"
          >
            <div class="state-breadcrumb">
              @for (insuranceClaimStatusFlow of insuranceClaimStatusFlowList; track insuranceClaimStatusFlow.statusId) {
                <li
                  [ngClass]="insuranceClaimStatusFlow.statusId == insuranceClaim.claimStatusId
                      ? ['active-' + insuranceClaimStatusFlow.statusColor]
                      : ''
                  "
                >
                  {{ insuranceClaimStatusFlow.label }}
                </li>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
